import objectAssign from 'object-assign';
import RestHelper from '../utils/RestHelper';

function saveCustomerData(customerData, endpoint) {
  const params = {
    params: customerData
  };
  return RestHelper
    .post(endpoint, params);
}

function getData(endpoint, headrs) {
  return RestHelper.get(endpoint, headrs);
}

export const getCustomerDataStarted = (dispatch) => {
  dispatch({
    type: 'GET_CUSTOMER_DATA_STARTED'
  });
};

export const getCustomerData = (dispatch, response) => {
  dispatch({
    type: 'GET_CUSTOMER_DATA_SUCCESSFUL',
    data: {
      customerDataResponseRdx: response.data
    }
  });
};

export const getCustomerDataError = (dispatch, error) => {
  dispatch({
    type: 'GET_CUSTOMER_DATA_ERROR',
    data: {
      error
    }
  });
};

export const loadDataInitiation = (dispatch, component) => {
  dispatch({
    type: 'INIT_CUSTOMER_DATA',
    data: {
      component
    }
  });
};

export const getCustomerDataById = (dispatch, endpoint) => {
  const resp = getData(endpoint, {});
  getCustomerDataStarted(dispatch);
  return resp
    .then((response) => {
      getCustomerData(dispatch, response);
    })
    .catch((err) => {
      getCustomerDataError(dispatch, err);
      console.error('getCustomerDataById', err); // eslint-disable-line no-console
    });
};

export const dataRequest = (dispatch, state) => {
  dispatch({
    type: 'SUBMIT_CUSTOMER_DATA',
    data: {
      values: state
    }
  });
};

export const dataRequestSuccess = (dispatch, response) => {
  dispatch({
    type: 'SUBMIT_SUCCESSFUL',
    data: {
      response: response.data
    }
  });
};

export const dataRequestError = (dispatch, error) => {
  dispatch({
    type: 'SUBMIT_ERROR',
    data: {
      saveCustomerDataErrRdx: error.data
    }
  });
};

export const submitData = (dispatch, data, submitEndpoint) => {
  const resp = saveCustomerData(data, submitEndpoint);
  dataRequest(dispatch, data, submitEndpoint);
  return resp
    .then((response) => {
      if (response.data.status.toLowerCase() === 'ok') {
        dataRequestSuccess(dispatch, response);
      } else {
        dataRequestError(dispatch, response);
      }
    }).catch((err) => {
      dataRequestError(dispatch, err);
      console.error(err); // eslint-disable-line no-console
    });
};

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case 'INIT_CUSTOMER_DATA': {
      return objectAssign({}, state, action.data);
    }
    case 'GET_CUSTOMER_DATA_STARTED': {
      return objectAssign({}, state, action.data, { isRequestPending: true });
    }
    case 'GET_CUSTOMER_DATA_SUCCESSFUL': {
      return objectAssign({}, state, action.data, { isRequestPending: false });
    }
    case 'GET_CUSTOMER_DATA_ERROR': {
      return Object.assign({}, state, action.data, {
        isRequestPending: false,
        isSuccess: false
      });
    }
    case 'SUBMIT_CUSTOMER_DATA': {
      return objectAssign({}, state, action.data, { isRequestPending: true });
    }
    case 'SUBMIT_SUCCESSFUL': {
      return objectAssign({}, state, action.data, { isRequestPending: false, isSuccess: true });
    }
    case 'SUBMIT_ERROR': {
      return objectAssign({}, state, action.data, { isRequestPending: false, isSuccess: false });
    }
    default:
      return state;
  }
}
